module.exports = __webpack_public_path__ + "img/help-black-text.0af0b280.svg";